import {inject, ref} from 'vue';

export default {
    install: (app, options) => {
        const importProcessing = ref(true);

        const getStatusProcessing = () => {
            importProcessing.value = true;

            window.lazy_axios.get('/imports/handle/status')
                .then((response) => {
                    importProcessing.value = response.data.there_is_process_for_imports;
                });
        };

        app.provide('importProcessing', importProcessing);
        app.provide('resetImportsProcessing', getStatusProcessing);
    },
}
